export default {
  api: {
    base_url: process.env.VUE_APP_BACKEND_BASE_URL || 'https://mps.dev.autosense-cloud.com',
  },
  recaptcha: {
    site_key: process.env.VUE_APP_RECAPTCHA_SITE_KEY || '',
  },
};
